import { render, staticRenderFns } from "./StudentsFollowUpSettingsTable.vue?vue&type=template&id=6596bc68&"
import script from "./StudentsFollowUpSettingsTable.vue?vue&type=script&lang=js&"
export * from "./StudentsFollowUpSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports